import logger from '@redbubble/next/logger';

export interface HandleOnCancelProps {
  onCancel: () => Promise<void>;
}

export const handleOnCancel = async ({ onCancel }: HandleOnCancelProps) => {
  await onCancel().catch((error) => {
    const message = `Failed to refresh cart after user canceled PayPal checkout flow: ${error.message}`;
    logger.error(
      {
        err: error,
        context: 'PayPalExpress/handlers/handleOnCancel',
        message,
      },
      message
    );
  });
};
